/**
 * ★★ WO — A PORTA DO PAINEL DE PRODUTIVIDADE, no molde do `REENVIO_DISPONIVEL`.
 *
 * Decisão do dono (2/out/2026): a seção fica **escondida da equipe** até o formato da tela
 * estar fechado. ⚠ Não é defeito nem reversão — é a tela indo ao ar para o gestor conferir
 * antes de a equipe vê-la.
 *
 * ★★ POR QUE UMA CONSTANTE, e não apagar o item do menu: apagar espalha a decisão por três
 * arquivos e torna a volta uma reconstrução. Aqui a volta é **uma linha** — `true` devolve
 * exatamente o comportamento do lote 2, e há um teste para CADA estado da bandeira, de modo
 * que ligar não é um salto no escuro.
 *
 * ★ E a decisão mora num lugar SÓ. `AppShell` (o item) e `App.jsx` (a rota) leem daqui. Foi
 * para isso que a guarda da VU existe: *"item que a equipe não vê no menu é rota em que ela
 * não entra"* — menu e rota derivando da mesma bandeira é o que torna o invariante barato.
 *
 * ⚠ ISTO NÃO É SEGURANÇA, é visibilidade. A autoridade continua sendo a regra do Firestore
 * (`papel in ['gestor','sdr']` no collectionGroup das interações): com a bandeira ligada ou
 * desligada, quem não é gestor nem SDR não lê interação nenhuma. Esconder a tela não protege
 * dado — quem protege é o servidor.
 */

/** ★ A BANDEIRA. `true` devolve o comportamento do lote 2 (equipe vê). */
export const PRODUTIVIDADE_LIBERADA = true;

/**
 * Os papéis que enxergam o ITEM DE MENU.
 *
 * ⚠ Sem `superadmin`: nenhum item de `NAVEGACAO` o lista (ele não pertence a clínica
 * nenhuma e cai em `/admin`). A rota, sim, o aceita — ver `App.jsx`.
 */
export const PAPEIS_MENU_PRODUTIVIDADE = PRODUTIVIDADE_LIBERADA ? ['gestor', 'sdr'] : ['gestor'];

/**
 * ★★ NÃO HÁ AVISO, E ISSO É A DECISÃO — não um esquecimento.
 *
 * A primeira versão deste ajuste mandava a equipe para a tela inicial com uma faixa laranja
 * explicando que a seção estava em ajuste. ⚠ O dono mandou tirar: **a equipe não deve saber
 * que a seção existe** até ser liberada. Um aviso que diz "isto existe, mas não para você"
 * anuncia justamente o que era para ficar quieto.
 *
 * ★ Então a recusa é SILENCIOSA: quem digitar `/produtividade` vai para a tela inicial e
 * pronto — nenhuma faixa, nenhum texto, nada no `state` da navegação.
 *
 * ⚠ Se alguém for reintroduzir um aviso aqui, saiba que está revertendo uma decisão de
 * produto, não consertando uma falta.
 */
